(function() {

  // Get the raw query string captured before Shopify stripped UTMs
  function getRawQuery() {
    try {
      return sessionStorage.getItem('SHOP_RAW_QUERY') || '';
    } catch(e) {
      return '';
    }
  }

  // Get a specific query param from the raw string
 function getQueryParam(name, raw) {
  if (!raw) return null;
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '=([^&#]*)', 'g');
  let match;
  let value = null;

  while ((match = regex.exec(raw)) !== null) {
    value = decodeURIComponent(match[1].replace(/\+/g, ' '));
  }

  return value;
}


  // Save a key/value to localStorage or cookie fallback
  function persistKey(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch(e) {
      const d = new Date();
      d.setTime(d.getTime() + 30*24*60*60*1000);
      document.cookie = key + '=' + encodeURIComponent(value) + ';expires=' + d.toUTCString() + ';path=/';
    }
  }

  // Read UTMs + click IDs
  function readUTMs() {
    const raw = getRawQuery();
    const utms = {};

    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(k => {
      const v = getQueryParam(k, raw);
      if(v) utms[k] = v;
    });

    const gclid  = getQueryParam('gclid', raw);
    const gbraid = getQueryParam('gbraid', raw);
    const wbraid = getQueryParam('wbraid', raw);
    const fbclid = getQueryParam('fbclid', raw);

    if(gclid || gbraid || wbraid) {
      utms.utm_source = 'google';
      utms.utm_medium = 'cpc';
      const campaign = getQueryParam('gad_campaignid', raw);
      if(campaign) utms.utm_campaign = campaign;
      if(gclid) utms.gclid = gclid;
      if(gbraid) utms.gbraid = gbraid;
      if(wbraid) utms.wbraid = wbraid;
    } else if(fbclid && !utms.utm_source) {
      utms.utm_source = 'facebook';
      utms.utm_medium = 'paid_social';
      utms.fbclid = fbclid;
    }

    return utms;
  }

  // Persist UTMs to localStorage
  function persistUTMs(utms) {
    Object.keys(utms).forEach(k => persistKey(k, utms[k]));
  }

  // Read persisted UTMs
  function getPersistedUTMs() {
    const keys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','gbraid','wbraid','fbclid'];
    const out = {};
    keys.forEach(k => {
      let v = null;
      try { v = localStorage.getItem(k); } catch(e){}
      if(!v && document.cookie) {
        const match = document.cookie.match(new RegExp('(^| )'+k+'=([^;]+)'));
        if(match) v = decodeURIComponent(match[2]);
      }
      if(v) out[k] = v;
    });
    return out;
  }

  // Push UTMs to Tidio
  function pushToTidio() {
    if(!window.tidioChatApi || typeof window.tidioChatApi.setVisitorData !== 'function') return;
    const data = getPersistedUTMs();
    if(Object.keys(data).length > 0){
      window.tidioChatApi.setVisitorData(data);
      window.tidioChatApi.setContactProperties(data);
    }
  }

  function onTidioReady() {
    pushToTidio();
  }

  // Initialize script
  function init() {
    const utmsNow = readUTMs();
    if(Object.keys(utmsNow).length > 0) persistUTMs(utmsNow);

    if(window.tidioChatApi && typeof window.tidioChatApi.on === 'function'){
      window.tidioChatApi.on('ready', onTidioReady);
    } else {
      document.addEventListener('tidioChat-ready', onTidioReady);
    }
  }

  if(document.readyState === 'complete' || document.readyState === 'interactive'){
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

})();
